import { render, staticRenderFns } from "./SidebarLive.vue?vue&type=template&id=2d27dc6a&scoped=true"
import script from "./SidebarLive.vue?vue&type=script&lang=ts"
export * from "./SidebarLive.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d27dc6a",
  null
  
)

export default component.exports